<template>
  <div v-if="materiel" class="mgt-20px">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns is-gapless">
          <div class="column">
            <h1 class="title is-size-3">
                <span v-if="!materiel.numerique">
                  {{$t('materiel.detail', { code: materiel.code }) }}
                </span>
              <span v-else>
                  {{$t('materiel.detailNumerique', { code: materiel.code }) }}
                </span>
              <b-tag v-if="!materiel.actif"
                      type="has-background-subMenu"
                      class="has-text-white mgl-5px">
                {{$t('materiel.archive')}}
              </b-tag>
              <tag-list class="mg-5px"
                v-if="materielTags.length > 0"
                :listes="materielTags"/>
            </h1>
            <app-breadcrumb :breadcrumb="breadcrumb"/>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="buttons">
          <dropdownButton
            type="is-addOrEdit"
            class="mgr-2"
            :permission="constantes.EMPLACEMENT.maj"
            :actions="actionSecondary"
            @click="goToModif">
              {{$t('general.button.edit') }}
          </dropdownButton>
          <b-dropdown class="button is-bottom-left has-text-left">
            <div slot="trigger" class="right">
              <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
              <b-icon icon="chevron-down" class="has-text-default"></b-icon>
            </div>
            <b-dropdown-item class="pdl-20px">
              <p class="has-text-icon-more is-size-7">
                {{$t('materiel.titleAccesRapide')}}
              </p>
            </b-dropdown-item>
            <b-dropdown-item class="is-paddingless"
                             v-for="(accesRapide, index) in genererAllAccesRapide" :key="index">
              <router-link-blank :to="{ name: accesRapide.name,
                                    params: accesRapide.params}"
                                 class="pdt-5px pdb-5px"
                                 classMessage="has-text-default is-size-6 is-block
                                   mgl-20px mgr-20px"
                                 classComposant="noTextDecoration"
                                 :message="accesRapide.libelle">
              </router-link-blank>
            </b-dropdown-item>
          </b-dropdown>
          <piece-jointe-button
            class="mgr-2"
            :perm="constantes.EMPLACEMENT.maj"
            autoSave>
          </piece-jointe-button>
        </div>
      </div>
    </div>
    <informations-generation-code-materiel v-if="materiel"
                                           :element="materiel"
                                           :dispositif="materiel.dispositif"
                                           :tree-link="true"
    />
    <div class="tab mgh-0">
      <ul>
        <li :class="{'is-active': activeTab === 'infoGenerale'}"
          @click="activeTab = 'infoGenerale'">
          {{ $t('materiel.materiel') }}
        </li>
        <li v-if="!materiel.numerique"
            :class="{'is-active': activeTab === 'ListeFaces'}"
            @click="activeTab = 'ListeFaces'">
          {{ $t('emplacement.tab.face') }}
        </li>
        <li :class="{'is-active': activeTab === 'technique'}"
            @click="activeTab = 'technique'">
          {{ $t('materiel.infoTechnique') }}
        </li>
        <li :class="{'is-active': activeTab === 'ListeOtTechnique'}"
            v-if="afficherLogistique"
            @click="activeTab = 'ListeOtTechnique'">
          {{ $t('materiel.otTechniques') }}
        </li>
        <li :class="{'is-active': activeTab === 'listeEtatHistorique'}"
          @click="activeTab = 'listeEtatHistorique'">
          {{ $t('patrimoine.patrimoineEtatHistorique.title') }}
        </li>
        <li :class="{'is-active': activeTab === 'NomenclatureMateriel'}"
            @click="activeTab = 'NomenclatureMateriel'">
          {{ $t('nomenclatureTechnique.title') }}
        </li>
      </ul>
    </div>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="materiel"
        @no="openPopUpPrevention = false"
        @yes="archiverMateriel"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t(('materiel.archivageDesarchiver.'
        + (materiel.actif ? 'archivage' : 'desarchivage')))"
        :mess-footer="$t(('materiel.infoArchivageDesarchivage.'
        + (materiel.actif ? 'archivage' : 'desarchivage')))">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpPreventionSuppression"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="materiel"
        @no="openPopUpPreventionSuppression = false"
        @yes="supprimerMateriel"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t('materiel.supprimer.titre')"
        :mess-footer="$t('materiel.supprimer.sousTitre')">
      </pop-up-prevention>
    </b-modal>
    <component :is="activeTab" :materiel="materiel"
               :idPatrimoine="materiel.id"
               :showPerPage="true"
               :disabled="true"
               :typePatrimoine="constantes.MATERIEL"
               v-if="materiel" :ids="idsOfPatrimoine"
               :data="materiel"
               :isPatrimoine="true">
    </component>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { get as getFormatAffiche } from '@/api/formatAffiche';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import dropdownButton from '@/components/general/button/dropdownButton';
import { get, archiver, supprimer } from '@/api/gabed/materiel';
import messageErreur from '@/services/general/messageErreur';
import genererElementMaterielNumerique from '@/services/gabed/materiel/genererElementMaterielNumerique';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import infoGenerale from '@/components/gabed/materiel/c_infoGenerale';
import technique from '@/components/gabed/materiel/c_technique';
import messageSucces from '@/services/general/messageSucces';
import validationMateriel from '@/services/gabed/materiel/validation';
import validationSuppressionMateriel from '@/services/gabed/materiel/validationSuppression';
import popUpPrevention from '@/components/general/popUpPrevention';
import ListeOtTechnique from '@/components/emplacementTechnique/listeOtTechnique';
import { MATERIEL } from '@/configuration/gabed/emplacement/emplacementConf';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import breadcrumb from '@/components/general/breadcrumb';
import ListeFaces from '@/components/gabed/materiel/l_facesMateriel';
import TagList from '@/components/general/tagList';
import informationsGenerationCodeMateriel from '@/components/gabed/materiel/informationsGenerationCodeMateriel';
import listeEtatHistorique from '@/components/patrimoineEtatHistorique/l_patrimoineEtatHistorique';
import NomenclatureMateriel from '@/components/gabed/materiel/nomenclatureMateriel';

const permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'c_materiel',
  data() {
    return {
      materiel: null,
      idsOfPatrimoine: [],
      constantes: {
        EMPLACEMENT,
        MATERIEL,
      },
      activeTab: null,
      errorPopUp: false,
      openPopUpPrevention: false,
      openPopUpPreventionSuppression: false,
      messagesErreurPopUp: [],
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    routerLinkBlank,
    dropdownButton,
    infoGenerale,
    technique,
    popUpPrevention,
    ListeOtTechnique,
    pieceJointeButton,
    ListeFaces,
    TagList,
    informationsGenerationCodeMateriel,
    listeEtatHistorique,
    NomenclatureMateriel,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    afficherLogistique() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        {
          title: this.$i18n.t('detailEmplacement.titleWithoutN'),
          route: { name: 'c.gabed.emplacement-detailEmplacement', params: { id: this.materiel.dispositif.emplacementId } },
          isActive: false,
        },
        { title: this.$i18n.t('materiel.detailWithoutCode'), route: '', isActive: true },
      ];
    },
    genererAllAccesRapide() {
      const accesRapides = [
        { name: 'l.baux.contrat-by-materiel', params: { typePatrimoine: MATERIEL, patrimoineId: this.materiel.id }, libelle: this.$t('materiel.contrat') },
      ];
      if (this.materiel.numerique) {
        accesRapides.push(
          { name: 'c.bodac.catalogue-ecranNumerique', params: { id: this.materiel.produitId }, libelle: this.$t('materiel.product') },
        );
      }
      return accesRapides;
    },
    disableDesarchiver() {
      return !this.materiel.actif && !this.materiel.dispositif.actif;
    },
    actionSecondary() {
      return [
        {
          label: this.$t('general.button.' + (this.materiel.actif ? 'archiver' : 'desarchiver')),
          action: () => {
            this.errorPopUp = false;
            this.messagesErreurPopUp = [];
            this.openPopUpPrevention = true;
          },
          permissionAction: EMPLACEMENT.supprimer,
          disabled: this.disableDesarchiver,
        },
        {
          label: this.$t('general.button.delete'),
          action: () => {
            this.errorPopUp = false;
            this.messagesErreurPopUp = [];
            this.openPopUpPreventionSuppression = true;
          },
          permissionAction: EMPLACEMENT.supprimer,
        },
      ];
    },
    moduleLogistiqueImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key);
    },
    materielTags() {
      if (!this.materiel.tags.length) return [];
      const tagIds = this.materiel.tags.map(t => t.tagId);
      return this.parametre(PARAMETRES_KEYS.tag).filter((t) => tagIds.includes(t.id));
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    goToModif() {
      this.$router.push({
        name: 'm.gabed.emplacement-materielEdition',
        params: { idMateriel: this.materiel.id },
      });
    },
    async archiverMateriel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        const materielArchive = (await archiver(this.materiel.id, this.materiel.actif))
          .data.result;
        messageSucces(this.$i18n.t('materiel.messages.success.' + (this.materiel.actif ? 'archivage' : 'desarchivage')));
        this.openPopUpPrevention = false;
        this.materiel.actif = materielArchive.actif;
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationMateriel(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async supprimerMateriel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await supprimer(this.materiel.id);
        messageSucces(this.$t('materiel.messages.success.supprimer'));
        this.openPopUpPreventionSuppression = false;
        this.$router.push({
          name: 'c.gabed.emplacement-detailDispositif',
          params: { idDispositif: this.materiel.dispositifId },
        });
      } catch (e) {
        if (e.response.data.error) {
          validationSuppressionMateriel(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getAllIds() {
      const ids = [];
      ids.push(this.materiel.id);
      this.materiel.faces.forEach((face) => {
        ids.push(face.id);
      });
      return ids;
    },
    updateActiveTab(activeTab) {
      this.activeTab = activeTab;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Materiel' });
      await this.setAttachmentElementId({ id: this.$route.params.idMateriel });
      await this.loadParametres([PARAMETRES_KEYS.materielFormat, PARAMETRES_KEYS.tag]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key,
        PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key]);
      const materielResult = (await get(this.$route.params.idMateriel)).data.result;
      if (materielResult?.nomenclature) {
        materielResult.nomenclature = JSON.parse(
          materielResult.nomenclature);
      }
      const { formatAfficheId } = materielResult.materielTechnique;
      if (formatAfficheId && this.moduleLogistiqueImpressionActive) {
        const formatAffiche = (await getFormatAffiche(formatAfficheId)).data.result;
        materielResult.materielTechnique.formatAffiche = formatAffiche;
      }
      this.materiel = materielResult;
      this.materiel.informationsNumeriques = genererElementMaterielNumerique();
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.materiel.code }));
      this.updateActiveTab(this.$route.params.activeTab ? this.$route.params.activeTab : 'infoGenerale');
      this.idsOfPatrimoine = this.getAllIds();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
